<div class="dialog-container">

<div class="dialog-header">
    <div class="header-content">
    <div class="icon-container">
        <i class="bi bi-globe"></i>
    </div>
    <div class="header-text">
        <h2 style="font-weight: 600">
          {{ data ? 'Edit Country Affiliation' : 'Add Country Affiliation' }}
        </h2>
        <p style="font-size: 13px;">Enter the details of your country affiliation</p>
    </div>
    </div>
    <img class="close-button" src="assets/images/close-circle.svg" alt="Close"  (click)="cancel()"/>
</div>

<div class="modal-body">
  <form [formGroup]="countryForm">

    <!-- Country Select -->
    <div class="form-group">
      <label for="country">Select Country <span class="errorStyle">*</span></label>
      <select class="form-control" id="country" formControlName="country" [(ngModel)]="selectedCountry" name="country" #countrySelect
        (change)="onCountryChange(countrySelect.value)" [ngClass]="{ 'disabled-select': isDisabled }" [disabled]="isDisabled">
        <option value="" disabled selected> Select Country </option>
        <option *ngFor="let item of countryList" [value]="item[0]">{{ item[1] }}</option>
        <option *ngIf="!countryList.length">{{ selectedCountry }}</option>
      </select>
    </div>

    <!-- Affiliation Selection -->
    <!-- <div class="form-group" *ngIf=" data?.index != 'citizen_primary'">
      <label for="affiliation">Select Country Affiliation <span class="errorStyle">*</span></label>
      <select class="form-control" id="affiliation" formControlName="affiliationType" [(ngModel)]="selectedAffiliation" name="affiliation">
        <option value="" disabled selected> </option>
        <option *ngFor="let aff of affList" [value]="aff.aflType">{{ aff.aflName }}</option>
      </select>
    </div> -->

    <div class="form-group" *ngIf="data?.index != 'citizen_primary'">
      <label for="affiliation">Select Country Affiliation <span class="errorStyle">*</span></label>
      <select class="form-control" id="affiliation" formControlName="affiliationType">
        <option value="" disabled> </option>
        <option *ngFor="let aff of affList" [value]="aff.aflType">{{ aff.aflName }}</option>
      </select>
    </div>
    <!-- Affiliation Selection -->

    <div class="form-group">
      <label for="home">Home Address <span class="errorStyle">*</span></label>
      <input type="text" class="form-control" formControlName="homeAddress" (keydown)="preventLeadingSpace($event)"  (input)="validateSpacesHome($event)" placeholder=" " id="home"/>
    </div>

    <div class="form-group">
      <label for="mobile">Mobile Number <span class="errorStyle">*</span></label>
      <input type="text" class="form-control" formControlName="mobile" placeholder=" " maxlength="10" id="mobile" 
        inputmode="numeric" pattern="[0-9()\+\-\s]*" (paste)="preventInvalidPaste($event)" (keypress)="allowOnlyNumbers($event)"/>
    </div>

    <div class="form-group">
        <label for="work">Work Address</label>
        <input type="text" class="form-control" formControlName="workAddress" (keydown)="preventLeadingSpace($event)"  (input)="validateSpacesWork($event)" placeholder=" " id="work" />
    </div>
    
    <div class="form-group">
        <label for="work">Work Number</label>
        <input type="text" class="form-control" formControlName="workNumber" placeholder=" " maxlength="10" id="work" 
          inputmode="numeric" pattern="[0-9()\+\-\s]*" (paste)="preventInvalidPaste($event)" (keypress)="allowOnlyNumbers($event)"/>
    </div>
    
    <div class="form-group">
        <label for="work">Alternate Number</label>
        <input type="text" class="form-control" formControlName="alternateNumber" placeholder=" " maxlength="10" id="work" 
          inputmode="numeric" pattern="[0-9()\+\-\s]*" (paste)="preventInvalidPaste($event)" (keypress)="allowOnlyNumbers($event)"/>
    </div>

  </form>
</div>

<div class="action-buttons">
  <button class="cancel-btn" (click)="cancel()">Cancel</button>
  <button class="save-btn" [disabled]="countryForm.invalid" (click)="save()">Save</button>
</div>

</div>
